import { Link } from 'react-router-dom';
import { Instagram } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { INSTAGRAM_URL } from '../content';

const Footer = () => {
    const { t } = useLanguage();
    const links = [
        { to: '/', label: t.nav.home },
        { to: '/gallery', label: t.nav.gallery },
        { to: '/about', label: t.nav.about },
        { to: '/cv', label: t.nav.cv },
        { to: '/shop', label: t.nav.shop },
        { to: '/contact', label: t.nav.contact },
    ];
    return (
        <footer className="px-6 md:px-12 pt-24 pb-12 max-w-[1600px] mx-auto" data-testid="footer">
            <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-8">
                <div className="md:col-span-5">
                    <img src="/images/art-01.jpg" alt="Robin Spencer signature" className="h-14 w-auto invert opacity-90 mb-6" />
                    <p className="font-serif text-3xl md:text-4xl tracking-tight text-paper">Robin Spencer</p>
                    <p className="mt-2 text-sm text-fog">{t.hero.kicker.split('—')[1]?.trim()}</p>
                </div>
                <nav className="md:col-span-3 flex flex-col gap-3" aria-label="Footer">
                    {links.map((l) => (
                        <Link
                            key={l.to}
                            to={l.to}
                            className="link-line w-fit text-sm text-fog hover:text-paper transition-colors duration-300"
                            data-testid={`footer-link-${l.to === '/' ? 'home' : l.to.slice(1)}`}
                        >
                            {l.label}
                        </Link>
                    ))}
                </nav>
                <div className="md:col-span-4">
                    <a
                        href={INSTAGRAM_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex items-center gap-3 group"
                        data-testid="footer-instagram-link"
                    >
                        <span className="flex items-center justify-center w-12 h-12 rounded-full border border-white/15 transition-colors duration-300 group-hover:border-dusk group-hover:bg-dusk/10">
                            <Instagram className="w-5 h-5 text-paper" strokeWidth={1.5} />
                        </span>
                        <span className="text-sm text-fog group-hover:text-paper transition-colors duration-300 max-w-[220px]">
                            {t.footer.instagram}
                        </span>
                    </a>
                </div>
            </div>
            <div className="mt-20 pt-8 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-4 text-xs text-fog/70">
                <span data-testid="footer-copyright">© 2026 Robin Spencer — {t.footer.rights}</span>
                <a href="https://www.robin-spencer.com/" target="_blank" rel="noopener noreferrer" className="hover:text-paper transition-colors duration-300">
                    www.robin-spencer.com
                </a>
            </div>
        </footer>
    );
};

export default Footer;
